import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-168dbbf4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "min-banner fadeInUp"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "携手共筑数字化未来", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description"
}, "亲笔签期待与您的合作", -1));
const _hoisted_4 = {
  class: "regist-guide"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fadeInUp"
}, "去除数字化社会最后一张纸", -1));
const _hoisted_6 = {
  class: "regist-guide_bc"
};
const _hoisted_7 = {
  class: "container fadeInUp"
};
const _hoisted_8 = {
  class: "guide-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "省级覆盖", -1));
const _hoisted_10 = {
  class: "guide-item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "城市覆盖", -1));
const _hoisted_12 = {
  class: "guide-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "服务次数", -1));
const _hoisted_14 = {
  class: "guide-item"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "节约纸张数", -1));
import SignMain from './part/sign-main';
import Board from './part/board';
import SpeclalList from './part/specialist';
import Case from './part/case';
import AuthView from './part/AuthView';
import AuthViewMobile from './part/AuthView/mobile';
import IndexBanner from '@/components/carousel';
import Partner from '@/components/partner'; // 生态伙伴
import GetForm from '@/components/form';
import Scene from '@/components/scene';
import { useRouter } from 'vue-router';
import { getAdInfo, getUrllink } from '@/api';
import { ref, reactive, onMounted } from 'vue';
import { isMobile, observe } from '@/utils';
import { CountTo } from 'vue3-count-to';
export default {
  __name: 'index',
  setup(__props) {
    const basePath = window.appConfig.VUE_APP_PATH;
    const bannerList = ref([]);
    const router = useRouter();
    const jumpToPartner = e => {
      if (e.target.tagName.toLowerCase() !== 'a') {
        router.push({
          path: `${basePath}partner`
        });
      }
    };
    const list = [{
      head: `签合同，就上亲笔签`,
      desc: `安全高效，4步完成签署`
    }, {
      head: '亲笔签，企业专属版',
      desc: '高效API集成，让业务系统快速具备电子签署能力'
    }, {
      head: '亲笔签，企业专享版',
      desc: '数字化签署赋能，本地部署、量身打造'
    }];
    const num1 = ref(null);
    const num2 = ref(null);
    const num3 = ref(null);
    const num4 = ref(null);
    onMounted(async () => {
      try {
        const res = await getAdInfo('1000');
        res.forEach((item, index) => {
          // 图片类型
          const obj = list[index];
          if (!obj.head) {
            obj = list[0];
          }
          if (item.type === 1) {
            obj.imgSrc = `${window.appConfig.apiUrl}/openApi/file/imagePreview/${item.img}`;
          }
          // 外链
          if (item.urlType === 1) {
            obj.link = item.url;
            obj.target = '_blank';
          }
          // 内链
          if (item.urlType === 2) {
            obj.link = item.url;
          }
          bannerList.value.push(obj);
        });
      } catch (err) {}
      observe(['.anim1', '.fadeInLeft', '.fadeInRight', '.fadeInUp', '.fadeInDown', '.fadeInDown_fast']);
      const $observe = new IntersectionObserver(changes => {
        for (const change of changes) {
          if (change.isIntersecting) {
            num1.value.start();
            num2.value.start();
            num3.value.start();
            num4.value.start();
          }
        }
      }, {
        threshold: 0.5
      });
      $observe.observe(document.querySelector('.regist-guide_bc'));
    });
    const goPage = async url => {
      if (!isMobile()) {
        return window.open(window.appConfig[url], '_blank');
      }
      const link = await getUrllink();
      location.href = link;
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _directive_track = _resolveDirective("track");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(IndexBanner), {
        list: bannerList.value
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", {
          class: "link-button",
          onClick: _cache[0] || (_cache[0] = $event => goPage('loginUrl'))
        }, [_createTextVNode(" 立即体验 ")])), [[_directive_track, {
          button_name: '立即体验',
          click_info: 'banner',
          event_source: '首页',
          event_source_pam: null,
          event_target: '亲笔签登录页',
          event_target_pam: null
        }]])]),
        _: 1
      }, 8, ["list"]), _createVNode(_unref(SignMain)), _createVNode(_unref(Board)), _createVNode(_unref(Scene)), !_unref(isMobile)() ? (_openBlock(), _createBlock(_unref(AuthView), {
        key: 0
      })) : (_openBlock(), _createBlock(_unref(AuthViewMobile), {
        key: 1
      })), _createVNode(_unref(Case), {
        class: "home-case"
      }), _createVNode(_unref(Partner), {
        class: "home-partner"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "container",
        onClick: _cache[1] || (_cache[1] = $event => jumpToPartner($event))
      }, [_hoisted_2, _hoisted_3, _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        class: "link-button",
        to: _unref(basePath) + 'partner/form'
      }, {
        default: _withCtx(() => [_createTextVNode("申请加入")]),
        _: 1
      }, 8, ["to"])), [[_directive_track, {
        button_name: '申请加入',
        click_info: '合作伙伴信息录入入口',
        event_source: '首页申请',
        event_source_pam: null,
        event_target: null,
        event_target_pam: null
      }]])])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("h3", null, [_createVNode(_unref(CountTo), {
        ref_key: "num1",
        ref: num1,
        startVal: 0,
        endVal: 10,
        duration: 3000,
        autoplay: false
      }, null, 512), _createTextVNode("+ ")]), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createElementVNode("h3", null, [_createVNode(_unref(CountTo), {
        ref_key: "num2",
        ref: num2,
        startVal: 0,
        endVal: 40,
        duration: 3000,
        autoplay: false
      }, null, 512), _createTextVNode("+ ")]), _hoisted_11]), _createElementVNode("div", _hoisted_12, [_createElementVNode("h3", null, [_createVNode(_unref(CountTo), {
        ref_key: "num3",
        ref: num3,
        startVal: 0,
        endVal: 5,
        duration: 3000,
        autoplay: false
      }, null, 512), _createTextVNode("亿+ ")]), _hoisted_13]), _createElementVNode("div", _hoisted_14, [_createElementVNode("h3", null, [_createVNode(_unref(CountTo), {
        ref_key: "num4",
        ref: num4,
        startVal: 0,
        endVal: 20,
        duration: 3000,
        autoplay: false
      }, null, 512), _createTextVNode("亿+ ")]), _hoisted_15])])])]), _createVNode(_unref(GetForm), {
        class: "form-bc",
        mainTitle: "立即体验电子签约全流程",
        desc: "为你的团队量身定制，多场景&多行业的解决方案"
      })], 64);
    };
  }
};